import { Modal, Button, Spinner, Form, Row, Col } from 'react-bootstrap';
import { useState } from 'react';
import axios from 'axios';

import { useHistory } from 'react-router';
import { useAuth } from '../../context/auth-context';
import { asyncWrap } from '../../utils/utils';
import { AiFillCheckCircle } from 'react-icons/ai';
import Swal from 'sweetalert2';
// Ensure this exists

const DigilockerAadhar = ({ show, setShow, userDetails }) => {
  const history = useHistory();
  const { user } = useAuth();

  const [aadhaarNumber, setAadhaarNumber] = useState(
    userDetails?.Aadharcardnumber
  );
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async () => {
    if (!aadhaarNumber.match(/^\d{12}$/)) {
      setError('Please enter a valid 12-digit Aadhaar number.');
      return;
    }

    setLoading(true);
    setError('');

    const [err, response] = await asyncWrap(
      axios.post('/verifyKyc/digilocker/send-aadhar-consent', {
        aadhaar_number: aadhaarNumber,
      })
    );

    if (err) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text:
          err.response?.data?.message ||
          'Something went wrong. Please try again.',
      });
      setLoading(false);
      return;
    }

    if (!response?.data?.data?.url) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: response?.data?.message || 'No URL returned from server.',
      });
      setLoading(false);
      return;
    } else if (response.data?.success) {
      setLoading(false);
      const redirectUrl = response.data.data.url;
      const a = document.createElement('a');
      a.href = redirectUrl;
      a.target = '_self'; // <-- ensure it opens in the same tab
      document.body.appendChild(a); // required in some browsers
      a.click();
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: response?.data?.message || 'Failed to send consent request.',
      });
      setLoading(false);
    }
  };

  return (
    <Modal fullscreen={true} show={show} onHide={() => setShow(false)}>
      <Modal.Header closeButton>
        {/* <Modal.Title>Digilocker Aadhaar Verification</Modal.Title> */}
      </Modal.Header>
      <Modal.Body
        style={{
          display: 'flex',
          alignItems: 'start',
          flexDirection: 'column',
          justifyContent: 'start',
        }}
      >
        <Row style={{ width: '100%' }}>
          <Col
            style={{
              display: 'flex',
              flexDirection: 'row',
              width: '100%',
            }}
          >
            <Form style={{ maxWidth: '400px', width: '100%' }}>
              <Form.Group className='mb-3'>
                <Form.Label>Enter Aadhaar Number</Form.Label>
                <Form.Control
                  type='text'
                  maxLength={12}
                  value={aadhaarNumber}
                  onChange={e => setAadhaarNumber(e.target.value)}
                  placeholder='Enter Aadhar Card Number'
                />
              </Form.Group>
            </Form>
            <div
              style={{
                width: '15%',
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              <AiFillCheckCircle
                style={{
                  height: 'auto',
                  width: '60%',
                  marginTop: '12px',
                  color: `${userDetails?.IsAadharVerified ? 'green' : 'black'}`,
                }}
              />
            </div>
          </Col>
        </Row>

        {error && (
          <div className='text-danger mb-3' style={{ fontSize: '0.9rem' }}>
            {error}
          </div>
        )}
        {!userDetails?.IsAadharVerified && (
          <>
            <Button
              variant='primary'
              onClick={handleSubmit}
              disabled={loading}
              className='w-100'
            >
              {loading ? (
                <>
                  <Spinner
                    as='span'
                    animation='border'
                    size='sm'
                    role='status'
                    aria-hidden='true'
                  />{' '}
                  Sending...
                </>
              ) : (
                'Verify via Digilocker'
              )}
            </Button>

            {/* </Form> */}
            {userDetails?.AadharVerificationMsg && (
              <div
                className='mt-3 text-warning'
                style={{ fontSize: '0.95rem' }}
              >
                Last verification error: {userDetails.AadharVerificationMsg}
              </div>
            )}
          </>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default DigilockerAadhar;
